@if (open) {
  <div class="fixed inset-0 z-[10000] flex items-end sm:items-center justify-center p-0 sm:p-4" role="dialog" aria-modal="true" aria-labelledby="donate-modal-title">
    <div class="absolute inset-0 bg-dark-text/60 backdrop-blur-sm" (click)="close()"></div>
    <div cntFocusTrap (escape)="close()"
      class="relative bg-white rounded-t-3xl sm:rounded-2xl shadow-[0_24px_48px_rgba(0,0,0,0.2)] max-w-md w-full max-h-[92dvh] sm:max-h-[88dvh] overflow-y-auto p-6 md:p-8">

      <button type="button" (click)="close()" aria-label="Close"
        class="absolute top-4 right-4 w-9 h-9 rounded-full inline-flex items-center justify-center hover:bg-cream/60 transition-colors">
        <span aria-hidden="true" class="material-symbols-outlined text-xl text-muted-text">close</span>
      </button>

      <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-jungle-green/10 mb-4">
        <span aria-hidden="true" class="material-symbols-outlined text-3xl text-jungle-green" style="font-variation-settings: 'FILL' 1;">volunteer_activism</span>
      </div>
      <h2 id="donate-modal-title" class="font-headline font-bold text-dark-text text-2xl tracking-tight mb-2">Tip {{ targetName || 'the caretaker' }}</h2>
      <p class="text-sm font-body text-muted-text leading-relaxed mb-6">
        Half goes straight to the caretaker as CurbNTurf Cash, half helps CurbNTurf maintain public-land properties.
      </p>

      @if (availableCash > 0) {
        <div class="flex items-start justify-between gap-3 mb-4 px-4 py-3 rounded-xl bg-trinidad/5 border border-trinidad/20">
          <div class="flex items-start gap-2">
            <span aria-hidden="true" class="material-symbols-outlined text-base text-trinidad mt-0.5" style="font-variation-settings: 'FILL' 1;">redeem</span>
            <div>
              <div class="text-sm font-body font-bold text-trinidad">CurbNTurf Cash — ${{ availableCash }} available</div>
              <div class="text-xs font-body text-muted-text">Applied automatically — up to ${{ availableCash }} comes off the card charge.</div>
            </div>
          </div>
        </div>
      }

      @if (needsCard && !hasRealCard) {
        <div class="rounded-xl bg-cream/40 border border-dark-text/8 p-4">
          <div class="text-sm font-body font-bold text-dark-text mb-1">Add a card</div>
          <p class="text-xs text-muted-text font-body mb-3">Donations require a card on file.</p>
          <div class="grid grid-cols-2 gap-3">
            <label class="flex flex-col gap-1 col-span-2">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">Card number</span>
              <input type="text" inputmode="numeric" autocomplete="cc-number" name="cardNumber" [(ngModel)]="cardNumber" cntMaskCCNum placeholder="4111 1111 1111 1111"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">Exp month (MM)</span>
              <input type="text" inputmode="numeric" maxlength="2" autocomplete="cc-exp-month" name="cardExpMonth" [(ngModel)]="cardExpMonth" placeholder="04"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">Exp year (YYYY)</span>
              <input type="text" inputmode="numeric" maxlength="4" autocomplete="cc-exp-year" name="cardExpYear" [(ngModel)]="cardExpYear" placeholder="2028"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">CVV</span>
              <input type="text" inputmode="numeric" maxlength="4" autocomplete="cc-csc" name="cardCvv" [(ngModel)]="cardCvv" cntMaskCCCvc placeholder="123"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">Billing zip</span>
              <input type="text" inputmode="numeric" maxlength="5" autocomplete="postal-code" name="cardZip" [(ngModel)]="cardZip" placeholder="97201"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1 col-span-2">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">Billing address</span>
              <input type="text" autocomplete="address-line1" name="cardAddress" [(ngModel)]="cardAddress" placeholder="123 Main St"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">City</span>
              <input type="text" autocomplete="address-level2" name="cardCity" [(ngModel)]="cardCity" placeholder="Portland"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-[0.6rem] font-label uppercase tracking-[0.1em] text-muted-text">State</span>
              <input type="text" autocomplete="address-level1" name="cardState" [(ngModel)]="cardState" placeholder="OR"
                class="bg-white border border-dark-text/15 rounded-xl px-3 py-2.5 text-sm font-body">
            </label>
          </div>
          @if (cardError) {
            <p role="alert" class="text-xs text-trinidad font-body mt-2">{{ cardError }}</p>
          }
          <div class="flex justify-end mt-3">
            <button type="button" (click)="addCard()" [disabled]="!canAddCard || savingCard"
              class="px-5 py-2.5 rounded-full bg-trinidad text-white text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 disabled:opacity-40 disabled:cursor-not-allowed">
              {{ savingCard ? 'Saving…' : 'Add card' }}
            </button>
          </div>
        </div>
      } @else {
        <div class="grid grid-cols-4 gap-2 mb-2">
          <button type="button" (click)="setAmount(5)"
            [ngClass]="amount === 5 && !customAmount ? 'bg-dark-text text-white border-dark-text' : 'bg-white text-dark-text border-dark-text/15 hover:border-trinidad'"
            class="py-2.5 rounded-full border text-xs uppercase tracking-[0.1em] font-button font-bold transition-colors">$5</button>
          <button type="button" (click)="setAmount(10)"
            [ngClass]="amount === 10 && !customAmount ? 'bg-dark-text text-white border-dark-text' : 'bg-white text-dark-text border-dark-text/15 hover:border-trinidad'"
            class="py-2.5 rounded-full border text-xs uppercase tracking-[0.1em] font-button font-bold transition-colors">$10</button>
          <button type="button" (click)="setAmount(20)"
            [ngClass]="amount === 20 && !customAmount ? 'bg-dark-text text-white border-dark-text' : 'bg-white text-dark-text border-dark-text/15 hover:border-trinidad'"
            class="py-2.5 rounded-full border text-xs uppercase tracking-[0.1em] font-button font-bold transition-colors">$20</button>
          <button type="button" (click)="setAmount(0)"
            [ngClass]="customAmount ? 'bg-dark-text text-white border-dark-text' : 'bg-white text-dark-text border-dark-text/15 hover:border-trinidad'"
            class="py-2.5 rounded-full border text-xs uppercase tracking-[0.1em] font-button font-bold transition-colors">Other</button>
        </div>

        @if (customAmount) {
          <label class="flex items-center gap-2 mb-4 px-4 py-2.5 rounded-full border border-dark-text/15 bg-white">
            <span class="text-dark-text font-body font-bold">$</span>
            <input #amountInput type="number" min="5" step="1" [(ngModel)]="amount" placeholder="Enter amount ($5 minimum)"
              class="flex-1 text-sm font-body outline-none">
          </label>
        }

        @if (cashPortion > 0 && amount !== null && amount >= 5) {
          @if (cardPortion > 0) {
            <p class="text-xs font-body text-muted-text mb-3">${{ cashPortion }} from CurbNTurf Cash + ${{ cardPortion }} charged to your card</p>
          } @else {
            <p class="text-xs font-body text-jungle-green mb-3">Fully covered by your CurbNTurf Cash — no card charge.</p>
          }
        }

        @if (error) {
          <p role="alert" class="text-xs text-trinidad font-body mb-3">{{ error }}</p>
        }

        <button type="button" (click)="donate()" [disabled]="!canDonate"
          class="w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-trinidad text-white text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 shadow-[0_8px_20px_rgba(227,83,13,0.25)] disabled:opacity-40 disabled:cursor-not-allowed transition-opacity">
          {{ submitting ? 'Processing…' : 'Donate $' + (amount ?? 0) }}
        </button>
      }
    </div>
  </div>
}
